import { createElement, Component, PropTypes } from 'rlink-react';

import ArticleSummary from './ArticleSummary';
import newsScene from 'helpers/scenes/newsScene';

export default class LatestNewsPanel extends Component {
  constructor (props) {
    super(props);
    this.state = {
      maxArticles: props.maxArticles,
    };
  }

  componentDidMount () {
    newsScene();
  }

  render () {
    let { articleSummaries } = this.props;
    let articlesToDisplay = [];
    let start = Math.max(articleSummaries.length - this.state.maxArticles, 0);
    let end = articleSummaries.length;
    articlesToDisplay = articleSummaries.slice(start, end).map(articleSummary => (
      <div key={articleSummary.slug}>
        <ArticleSummary
          articleSummary={articleSummary}
          slug={articleSummary.slug}
          isExternal={articleSummary.isExternal}
          externalUrl={articleSummary.externalUrl} />
      </div>
    )).reverse();

    return (
      <section id="node-30" className="node node-single-page-section node-promoted view-mode-full">
        <article id="news" className="layout-standard bg-white text-black clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Latest News</h2>
              <div className="view view-news view-id-news view-display-id-latest_news view-dom-id-5ebecf996e52543a9a2117e494555979">
                <div className="view-content">
                  <div>
                    {articlesToDisplay}
                  </div>
                </div>
                <div className="item-list">
                  <ul className={`pager pager-load-more ${this.state.maxArticles >= articleSummaries.length ? 'pager-load-more-empty' : ''}`}>
                    <li className="pager-next first last">
                      {(this.state.maxArticles < articleSummaries.length)
                        ? <a onClick={() => this.setState({maxArticles: this.state.maxArticles + this.props.showMoreAmount})}>Load More</a>
                        : ''}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

LatestNewsPanel.propTypes = {
  articleSummaries: PropTypes.arrayOf(PropTypes.object),
  maxArticles: PropTypes.number,
  showMoreAmount: PropTypes.number,
};

LatestNewsPanel.defaultProps = {
  maxArticles: 4,
  showMoreAmount: 4,
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/News/LatestNewsPanel.jsx